import React from 'react';
import { Link } from 'react-router-dom';

const Header = () => {

    const navItems = <>
        <li><Link to='/' >Home</Link></li>
        <li><Link to='/reading-history' >Reading History</Link></li>
        <li><Link to='/dashboard' >Dashboard</Link></li>
    </>

    return (
        <div className="navbar bg-base-200">
            <div className="navbar-start">
                <div className="dropdown">
                    <label tabIndex={0} className="btn btn-ghost lg:hidden">
                        <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6h16M4 12h8m-8 6h16" /></svg>
                    </label>
                    <ul tabIndex={0} className="menu menu-sm dropdown-content mt-3 z-[1] p-2 shadow bg-base-100 rounded-box w-52">
                        {
                            navItems
                        }
                    </ul>
                </div>
                <Link to='/' className="btn btn-ghost normal-case text-xl">Techno Verse</Link>
            </div>
            <div className="navbar-end hidden lg:flex">
                <ul className="menu menu-horizontal px-1">
                    {
                        navItems
                    }
                </ul>
            </div>
            <label htmlFor="my-drawer-2" className="btn btn-sm drawer-button lg:hidden ml-auto">Dashboard</label>
        </div>
    );
};

export default Header;